import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/Arrow_Circle.svg'
import _imports_1 from '@/assets/Check_Circle.svg'
import _imports_2 from '@/assets/Phone_Circle.svg'
import _imports_3 from '@/assets/Plane_Circle.svg'


const _withScopeId = n => (_pushScopeId("data-v-2fa039d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "disclaimer-container" }
const _hoisted_2 = { class: "disclaimer-inner-container" }
const _hoisted_3 = { class: "logo-wrapper" }
const _hoisted_4 = {
  key: 0,
  class: "skeleton skeleton-logo"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 2,
  class: "tenant-name-fallback"
}
const _hoisted_7 = { class: "header" }
const _hoisted_8 = { class: "header-text" }
const _hoisted_9 = { class: "layout-subtitle" }
const _hoisted_10 = { class: "layout-title" }
const _hoisted_11 = { class: "steps" }
const _hoisted_12 = { class: "step-item" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon-stack" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "icon-box" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: "Bullseye"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "vertical-line" })
], -1))
const _hoisted_14 = { class: "step-text" }
const _hoisted_15 = { class: "step-item" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon-stack" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "icon-box" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_1,
      alt: "Check"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "vertical-line" })
], -1))
const _hoisted_17 = { class: "step-text" }
const _hoisted_18 = { class: "step-item" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon-stack" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "icon-box" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_2,
      alt: "Phone"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "vertical-line" })
], -1))
const _hoisted_20 = { class: "step-text" }
const _hoisted_21 = { class: "step-item" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon-stack" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "icon-box" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_3,
      alt: "Send"
    })
  ])
], -1))
const _hoisted_23 = { class: "step-text" }
const _hoisted_24 = { class: "button-footer-group" }
const _hoisted_25 = {
  key: 1,
  class: "skeleton skeleton-button"
}
const _hoisted_26 = { class: "consent-overlay" }
const _hoisted_27 = { class: "consent-card" }
const _hoisted_28 = { class: "consent-header" }
const _hoisted_29 = { class: "consent-body" }
const _hoisted_30 = { class: "disclaimer-text" }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = ["href"]
const _hoisted_33 = {
  key: 1,
  class: "skeleton skeleton-disclaimer-block"
}
const _hoisted_34 = { class: "card-base success-card" }
const _hoisted_35 = { class: "header" }
const _hoisted_36 = { class: "header-text" }
const _hoisted_37 = { class: "layout-title" }
const _hoisted_38 = { class: "description" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_41 = { class: "qr-wrapper" }
const _hoisted_42 = { class: "qr-box" }
const _hoisted_43 = {
  key: 0,
  class: "skeleton skeleton-qr-overlay"
}
const _hoisted_44 = { class: "disclaimer-footer-outer" }
const _hoisted_45 = { class: "footer-links external" }
const _hoisted_46 = { key: 0 }
const _hoisted_47 = { key: 1 }
const _hoisted_48 = ["href"]
const _hoisted_49 = { key: 2 }
const _hoisted_50 = ["href"]
const _hoisted_51 = { class: "consent-overlay" }
const _hoisted_52 = { class: "consent-card" }
const _hoisted_53 = { class: "consent-header" }
const _hoisted_54 = { class: "consent-body" }
const _hoisted_55 = { class: "disclaimer-text" }
const _hoisted_56 = { key: 0 }
const _hoisted_57 = ["href"]

import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { faCheckCircle as faCheckCircleSolid } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import Cookies from 'js-cookie';
import { computed, onMounted, ref, watchEffect } from 'vue';
import { useI18n } from 'vue-i18n';
import { LocationQuery, useRoute } from 'vue-router';

import { showErrorMsgToast } from '@/common';
import {
  AiDisclaimerRequestDto,
  DisclaimerTargetResponse,
  DisclaimerTextResponseDto,
  GetDisclaimerRequest,
  ShortUrlEntity,
  ShortUrlRequest,
} from '@/store/models';
import privacyConfirmModule from '@/store/modules/privacyConfirmModule';
import shortUrlModule from '@/store/modules/shortUrlModule';
import tenantModule from '@/store/modules/tenantModule';

import LoadingIndicator from '@/components/LoadingIndicator.vue';
import QrCodeComp from '@/components/QrCodeComp.vue';
import router from '@/router/router';

const defaultWhatsAppGreen = 'rgb(69, 189, 89)';


export default /*#__PURE__*/_defineComponent({
  __name: 'AppDisclaimer',
  props: ['query'],
  setup(__props) {

const props = __props;
const query = ref<LocationQuery | undefined>(props.query);

const step = ref(1);
const showQrCode = ref(false);
const qrCodeLink = ref('');
const tenantIdentifier = ref<string | null>(null);
const language = ref(navigator.language);
const defaultLanguageCode = ref('de');
const disclaimerGuid = ref<string>();
const disclaimerTarget = ref<DisclaimerTargetResponse | null>(null);
const dataPrivacyUrl = ref<string | null>(null);
const redirectUrl = ref('');
const alternateUrl = ref('');
const useDirectUrl = ref(true);
const useWindowOpen = ref(true);
const route = useRoute();
const { t, te, locale } = useI18n();
const showDisclaimerText = ref(false);
const disclaimerData = ref<DisclaimerTextResponseDto>({
  languageCode: '',
  text: '',
  placeholders: [],
  remoteSystemType: '',
  disclaimerType: '',
});
const acceptWhatsappDataPrivacy = ref(true);
const acceptTalentPool = ref(false);
const talentPoolDisclaimer = ref(false); // overwrite this if set by API later
const hideDisclaimerCheckbox = ref(false);
const tenantLogoGuid = ref<string | null>(null);
const customDisclaimer = ref(false);
const contactDisclaimer = ref(false);
const showSubmitBtn = ref(false);
const logoPath = ref('/api/media/v1/logo/');
const loading = ref(false);
const qrImageLoaded = ref(false);
const tenantLogoLoaded = ref(false);
const isAiDisclaimer = query.value?.aiDisclaimer === 'true';
const jobTitleParam = query.value?.title as string | undefined;
const isJobTitleResolved = ref(false);
const remoteSystemType = ref<string | null>(null);
const displayDisclaimer = ref(false);
const hasValidConsent = ref(false);
const tenantLogoLoading = ref(true);

onMounted(async () => {
  locale.value = currentLanguage() as string;
  await onInitialPageLoad(); // Wait for both tenant and disclaimer setup.
});

watchEffect(() => {
  if (
    step.value === 3 &&
    qrCodeLink.value &&
    qrImageLoaded.value &&
    tenantLogoLoaded.value
  ) {
    loading.value = false;
  }
});

const tenantInfo = computed(() => tenantModule.tenantInfoLite);
const enableJobTitle = computed(
  () => tenantInfo.value?.enableDisclaimerJobTitle || isAiDisclaimer,
);
const primaryColor = computed(() => {
  return (
    tenantInfo.value?.primaryColor ||
    tenantInfo.value?.secondaryColor ||
    defaultWhatsAppGreen
  );
});

const tenantLogoGuidComputed = computed(() =>{
  return tenantLogoGuid.value;
});

// const defaultAiText = computed(() => {
//   const raw = tenantInfo.value?.aiDefaultText || '';
//   return raw.replace('{tenantName}', tenantInfo.value?.name || '');
// });

const defaultWhatsappText = computed(() => {
  const raw = tenantInfo.value?.whatsAppDefaultText || '';
  return raw.replace('{tenantName}', tenantInfo.value?.name || '');
});

const colorReady = computed(() => {
  return tenantInfo.value !== null; // resolves as soon as tenant info is loaded
});

const resolvedPrimaryColor = computed(() => {
  if (!colorReady.value) return null;
  return (
    tenantInfo.value?.primaryColor ||
    tenantInfo.value?.secondaryColor ||
    defaultWhatsAppGreen
  );
});

// Final display job title based on full logic
const displayTitle = computed(() => {
  if (jobTitleParam) return jobTitleParam;
  if (isAiDisclaimer) return '';
  if (enableJobTitle.value && disclaimerTarget.value) {
    const titleFromShortUrl =
      disclaimerTarget.value?.shortUrlDto?.disclaimerJobTitle;
    return titleFromShortUrl || defaultWhatsappText.value;
  }
  if(!disclaimerTarget.value){
    return '';
  }
  return defaultWhatsappText.value;
});

async function onInitialPageLoad() {
  loading.value = true;
  try {
    showQrCode.value = false;
    await loadTenantInfoLite();
    if (tenantModule.tenantInfoLite) {
      defaultLanguageCode.value =
        tenantModule.tenantInfoLite.defaultLanguageCode;
      tenantLogoGuid.value = tenantModule.tenantInfoLite.logoGuid || null;
      customDisclaimer.value = tenantModule.tenantInfoLite.customDisclaimer;
    }
    await getDisclaimerTarget();
    if (disclaimerTarget.value) {
      if (disclaimerTarget.value.dataPrivacyUrl) {
        dataPrivacyUrl.value = disclaimerTarget.value.dataPrivacyUrl;
      }
      contactDisclaimer.value =
        disclaimerTarget.value.shortUrlDto.contactDisclaimer;
      talentPoolDisclaimer.value =
        disclaimerTarget.value.shortUrlDto.talentPoolDisclaimer || false;
    }
    if (
      isMobileDevice() &&
      disclaimerTarget.value &&
      disclaimerTarget.value.shortUrlDto &&
      disclaimerTarget.value.shortUrlDto.directAccess
    ) {
      handleDirectAccess(disclaimerTarget.value);
    } else {
      // if (
      //   disclaimerTarget.value &&
      //   disclaimerTarget.value.shortUrlDto &&
      //   !disclaimerTarget.value.shortUrlDto.hideDisclaimer
      // ) {
      //   if (
      //     !isMobileDevice() ||
      //     !customDisclaimer.value ||
      //     (customDisclaimer.value && hideDisclaimerCheckbox.value)
      //   ) {
      showDisclaimerText.value = true;
      //   }
      // }
      showSubmitBtn.value = true;
    }
  } catch (error) {
    console.log(error);
  } finally {
    loading.value = false;
  }
}

async function loadTenantInfoLite() {
  try {
    const tenant = tenantModule.tenantInfoLite || null;
    if (!tenant) {
      await tenantModule.loadTenantInfoLite(locale.value);
    }
    if (tenantModule.tenantInfoLite) {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const enableWhatsApp = tenantModule.tenantInfoLite.enableWhatsapp;
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const readOnlyTenant = tenantModule.tenantInfoLite.readonly;
      const salesTokenSet = query.value?.sid || route.params.sid;
      tenantModule.tenantInfoLite.hideClientDataSecurity;
      if (!enableWhatsApp || (readOnlyTenant && !salesTokenSet)) {
        router.replace({ path: `/${query.value?.id}` }); // redirect to PY Home page via backend call eg. api/dispatch/v1. Replace later with the better approach if any.
        if (
          salesTokenSet &&
          !(await privacyConfirmModule.validateTestUserToken(
            salesTokenSet as string,
          ))
        ) {
          router.replace({ path: `/${query.value?.id}` }); // redirect to PY Home page via backend call eg. api/dispatch/v1. Replace later with the better approach if any.
        }
      }
      dataPrivacyUrl.value = tenantModule.tenantInfoLite.dataPrivacyUrl || null;
      tenantIdentifier.value = tenantModule.tenantInfoLite.identifier || null;
      tenantLogoGuid.value = tenantModule.tenantInfoLite.logoGuid || null;
      remoteSystemType.value =
        tenantModule.tenantInfoLite.remoteSystemType || null;
      hideDisclaimerCheckbox.value =
        tenantModule.tenantInfoLite.hideDisclaimerCheckbox || false;
      if (hideDisclaimerCheckbox.value) {
        acceptWhatsappDataPrivacy.value = true;
        acceptTalentPool.value = true;
      }
    }
  } catch (error) {
    console.log(error);
  }
}

async function loadDisclaimerData() {
  if (!tenantIdentifier.value) return;
  const req: GetDisclaimerRequest = {
    tenantIdentifier: tenantIdentifier.value,
    language: locale.value,
    remoteSystemType: remoteSystemType.value || '',
    disclaimerType: 'WHATSAPP',
    customDisclaimer: customDisclaimer.value,
  };
  disclaimerData.value = await privacyConfirmModule.getDisclaimer(req);
}

function closeConsentCard() {
  //close the overlay and show the disclaimer card again
  step.value = 1;
}

async function onAgreeDisclaimer() {
  loading.value = true;
  qrImageLoaded.value = false;

  try {
    if (isMobileDevice()) {
      if (
        disclaimerTarget.value &&
        disclaimerTarget.value.shortUrlDto?.hideDisclaimer
      ) {
        step.value = 3;
        await getDisclaimerTarget(); // refresh data
        handleDirectAccess(disclaimerTarget.value);
        return;
      }

      // Require checkbox to be ticked
      // if (!acceptWhatsappDataPrivacy.value) {
      //   step.value = 2;
      //   return;
      // }

      step.value = 3;

      if (isAiDisclaimer) {
        await applyAiDisclaimer();
      } else {
        await applyDisclaimer();
      }

      if (disclaimerTarget.value) {
        handleDirectAccess(disclaimerTarget.value);
      } else {
        showErrorMsgToast('Unable to proceed with WhatsApp application.');
      }
    } else {
      const consentValue =
        (acceptWhatsappDataPrivacy.value && !talentPoolDisclaimer.value) ||
        (acceptWhatsappDataPrivacy.value &&
          talentPoolDisclaimer.value &&
          acceptTalentPool.value) || (disclaimerTarget.value && disclaimerTarget.value.shortUrlDto && 
        disclaimerTarget.value.shortUrlDto.hideDisclaimer);
      hasValidConsent.value = consentValue? consentValue:false;
      if (hasValidConsent.value) {
        step.value = 3;
        if (disclaimerTarget.value?.shortUrlDto?.hideDisclaimer) {
          await getDisclaimerTarget();
        } else if (isAiDisclaimer) {
          await applyAiDisclaimer();
        } else {
          await applyDisclaimer();
        }

        if (disclaimerTarget.value) {
          handleDirectAccess(disclaimerTarget.value);
        } else {
          showErrorMsgToast('Unable to proceed with WhatsApp application.');
        }
      }
    }
  } catch (error) {
    console.error(error);
    showErrorMsgToast('Something went wrong during redirection.');
  } finally {
    loading.value = false;
  }
}

async function applyDisclaimer() {
  try {
    const request: ShortUrlRequest = getShortUrlRequest();
    request.dataPrivacyUrl = dataPrivacyUrl.value || '';
    if (talentPoolDisclaimer.value && acceptTalentPool.value) {
      request.acceptTalentPool = true;
    }
    disclaimerTarget.value = await shortUrlModule.doApplyDisclaimer(request);
  } catch (error) {
    console.error('applyDisclaimer error', error);
  }
}

async function applyAiDisclaimer() {
  try {
    setCookie();
    const disclaimerRequest: AiDisclaimerRequestDto = {
      platformType: getPlatform(),
      languageCode: currentLanguage(),
      userAgent: navigator.userAgent,
      additionalParams: JSON.stringify(query.value),
      disclaimerGuid: disclaimerGuid.value ? disclaimerGuid.value : '',
      countryCode: navigator.language,
      channelType: 'WB',
    };
    if (query.value?.utm_source) {
      disclaimerRequest.utm_source =
        (query.value?.utm_source as string) || undefined;
    }

    if (query.value?.utm_medium) {
      disclaimerRequest.utm_medium =
        (query.value?.utm_medium as string) || undefined;
    }

    if (query.value?.utm_campaign) {
      disclaimerRequest.utm_campaign =
        (query.value?.utm_campaign as string) || undefined;
    }

    if (query.value?.utm_content) {
      disclaimerRequest.utm_content =
        (query.value?.utm_content as string) || undefined;
    }
    const aiDisclaimerResponseDto =
      await shortUrlModule.doApplyAiDisclaimer(disclaimerRequest);
    const shorturlDto: ShortUrlEntity = {
      directAccessRedirectUrl: aiDisclaimerResponseDto.redirectUrl,
      directAccessFirstMessageText: aiDisclaimerResponseDto.messageText,
      alternateAccessRedirectUrl: aiDisclaimerResponseDto.redirectUrl,
      guid: '',
      type: '',
      channelType: '',
      translateEnabled: false,
      tenantLanguageCode: '',
      directAccess: false,
      hideDisclaimer: false,
      contactDisclaimer: false,
    };
    const targetResponse: DisclaimerTargetResponse = {
      dataPrivacyUrl: dataPrivacyUrl.value as string,
      shortUrlDto: shorturlDto,
    };
    disclaimerTarget.value = targetResponse;
  } catch (error) {
    console.log(error);
  }
}

async function getDisclaimerTarget() {
  loading.value = true;
  try {
    disclaimerTarget.value =
      await shortUrlModule.doGetDisclaimerTarget(getShortUrlRequest());
    isJobTitleResolved.value = true; // mark job title as loaded
    // console.log(
    //   'disclaimerTarget jobextern key',
    //   disclaimerTarget.value.shortUrlDto.jobSlug,
    // );
  } catch (error) {
    console.error('getDisclaimerTarget error', error);
    showErrorMsgToast('Unable to fetch disclaimer details.');
  } finally {
    loading.value = false;
  }
}

// const showTitleBlock = computed(() => {
//   return isJobTitleResolved.value && Boolean(displayTitle.value);
// });

function handleDirectAccess(target: DisclaimerTargetResponse) {
  const dto = target.shortUrlDto;
  if (
    !dto ||
    !dto.directAccessRedirectUrl ||
    !dto.alternateAccessRedirectUrl ||
    !dto.directAccessFirstMessageText
  ) {
    console.warn('Missing required redirect fields in shortUrlDto');
    return;
  }

  redirectUrl.value =
    dto.directAccessRedirectUrl + dto.directAccessFirstMessageText;
  alternateUrl.value =
    dto.alternateAccessRedirectUrl + dto.directAccessFirstMessageText;
  qrCodeLink.value = redirectUrl.value;

  qrImageLoaded.value = false; // reset before image loads
  step.value = 3; // show the wrapper

  if (isMobileDevice()) {
    window.location.href = redirectUrl.value;
  }
}

function currentLanguage(): string {
  if (language.value && language.value.length > 2) {
    return language.value.substring(0, 2);
  }

  return language.value;
}

function handleRedirectFromBtn() {
  const url = useDirectUrl.value ? redirectUrl.value : alternateUrl.value;
  useWindowOpen.value
    ? window.open(url, '_system')
    : (window.location.href = url);
  useWindowOpen.value = !useWindowOpen.value;
}

function getShortUrlRequest(): ShortUrlRequest {
  setCookie();
  const guidParam =
    (query.value?.id as string) || (query.value?.param as string);

  const request: ShortUrlRequest = {
    guid: guidParam,
    externalCall:
      query.value && query.value?.extcall
        ? (query.value?.extcall as unknown as boolean)
        : false,
    apiCall:
      query.value && query.value?.apicall
        ? (query.value?.apicall as unknown as boolean)
        : false,
    jkey:
      query.value && query.value?.jkey
        ? (query.value?.jkey as string)
        : undefined,
    languageCode: currentLanguage(),
    countryCode: navigator.language,
    additionalParams: JSON.stringify(query.value),
    disclaimerGuid: disclaimerGuid.value,
    platformType: getPlatform(),
    directRedirect:
      disclaimerTarget.value && disclaimerTarget.value.shortUrlDto
        ? disclaimerTarget.value.shortUrlDto.hideDisclaimer
        : false,
    aiDisclaimerTarget: isAiDisclaimer,
  };

  if (query.value?.utm_source) {
    request.utm_source = (query.value?.utm_source as string) || undefined;
  }

  if (query.value?.utm_medium) {
    request.utm_medium = (query.value?.utm_medium as string) || undefined;
  }

  if (query.value?.utm_campaign) {
    request.utm_campaign = (query.value?.utm_campaign as string) || undefined;
  }

  if (query.value?.utm_content) {
    request.utm_content = (query.value?.utm_content as string) || undefined;
  }

  if (query.value?.title) {
    request.title = (query.value?.title as string) || undefined;
  }
  if (query.value?.company) {
    request.company = (query.value?.company as string) || undefined;
  }

  if (query.value?.externalJobId) {
    request.externalJobId = (query.value?.externalJobId as string) || undefined;
  }

  request.channelType = 'WB';
  request.userAgent = navigator.userAgent;
  return request;
}

function getPlatform(): string {
  const ua = navigator.userAgent.toLowerCase();

  if (/android/.test(ua)) return 'ANDROID';
  if (/iphone|ipad|ipod/.test(ua)) return 'IOS';

  if (/chrome/.test(ua) && !/edg/.test(ua)) return 'CHROME';
  if (/firefox/.test(ua)) return 'FIREFOX';
  if (/edg/.test(ua)) return 'CHROME'; // treat Edge as Chrome (Chromium-based)

  return 'DESKTOP'; // fallback for anything not mobile or recognized
}

function setCookie(): void {
  disclaimerGuid.value = Cookies.get('disclaimerGuid') ?? generateGuid();
  Cookies.set('disclaimerGuid', disclaimerGuid.value);
}

function generateGuid(): string {
  return (
    Math.random().toString(36).substring(2, 6) +
    Math.random().toString(36).substring(2, 6)
  ).toUpperCase();
}

function isMobileDevice(): boolean {
  return /Mobi|Android/i.test(navigator.userAgent);
}

const tenantLogoLoadedComputed = computed(() => {
    return tenantLogoLoaded.value;
});

const tenantLogoLoadingComputed = computed(() => {
    return tenantLogoLoading.value;
});

function handleImageLoad(){
  tenantLogoLoading.value = false;
    tenantLogoLoaded.value = true;
}

function handleImageError(event: Event) {
  const target = event.target as HTMLImageElement;
  target.style.display = 'none';
  tenantLogoLoaded.value = false;
  tenantLogoLoading.value=false;
  // tenantLogoGuid.value = null; // force fallback to tenant name
}

function isPlaceholder(part: string): boolean {
  return part.startsWith('{') && part.endsWith('}');
}

function getPlaceholderLink(placeholder: string): string {
  const key = placeholder.slice(1, -1);
  return (
    disclaimerData.value.placeholders.find((p) => p.placeholderKey === key)
      ?.url ?? '#'
  );
}

function getPlaceholderLabel(placeholder: string): string {
  const key = placeholder.slice(1, -1);
  return (
    disclaimerData.value.placeholders.find((p) => p.placeholderKey === key)
      ?.labelText ?? placeholder
  );
}

const combinedDataPrivacyText = computed(() => {
  const text = disclaimerData.value.text;
  return text ? text.split(/(\{[a-zA-Z0-9_]+\})/) : [];
});

// function onTenantLogoLoaded() {
//   tenantLogoLoaded.value = true;
//   checkStep3AssetsReady();
// }

// function onTenantLogoError(event: Event) {
//   const target = event.target as HTMLImageElement;
//   target.style.display = 'none';
//   tenantLogoLoaded.value = false; // even on error, we let UI proceed
//   tenantLogoGuid.value = null;
//   checkStep3AssetsReady();
// }

function onQrCodeReady() {
  qrImageLoaded.value = true;
  checkStep3AssetsReady();
}

function checkStep3AssetsReady() {
  if (qrImageLoaded.value && tenantLogoLoaded.value) {
    loading.value = false;
  }
}

function getDisplayText(key: string) {
  const aiKey = key + '_ai';
  const mobileKey = key + '_mobile';
  const mobileAiKey = key + '_ai_mobile';

  if (isMobileDevice()) {
    if (isAiDisclaimer) {
      if (te(mobileAiKey)) {
        return t(mobileAiKey);
      } else if (te(aiKey)) {
        return t(aiKey);
      }
    }
    if (te(mobileKey)) {
      return t(mobileKey);
    }
  }
  if (isAiDisclaimer) {
    if (te(aiKey)) {
      return t(aiKey);
    }
  }

  return t(key);
}
// Handles the click on the WhatsApp apply button (step 1)
async function handleRedirectToDisclaimer() {
  loading.value = true;
  try {
    if (showDisclaimerText.value) {
      await loadDisclaimerData();
      step.value = 2;
    }
  } catch (error) {
    console.error('Error in handleRedirectToDisclaimer:', error);
    showErrorMsgToast('Something went wrong. Please try again.');
  } finally {
    loading.value = false;
  }
}

function showDisclaimer(){
  displayDisclaimer.value = true
}

function closeDisclaimer(){
  displayDisclaimer.value = false;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(LoadingIndicator, { showLoading: loading.value }, null, 8, ["showLoading"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (tenantLogoGuidComputed.value && tenantLogoLoadingComputed.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4))
          : _createCommentVNode("", true),
        (tenantLogoGuidComputed.value)
          ? (_openBlock(), _createElementBlock("img", {
              key: 1,
              src: logoPath.value + tenantLogoGuidComputed.value,
              onLoad: handleImageLoad,
              onError: handleImageError,
              alt: "Tenant Logo",
              class: _normalizeClass(["tenant-logo-img", { 'is-loaded': tenantLogoLoadedComputed.value }])
            }, null, 42, _hoisted_5))
          : _createCommentVNode("", true),
        (!tenantLogoGuidComputed.value || (!tenantLogoLoadingComputed.value &&!tenantLogoLoadedComputed.value))
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(tenantInfo.value?.name || tenantInfo.value?.identifier || ""), 1))
          : _createCommentVNode("", true)
      ]),
      _withDirectives(_createElementVNode("div", {
        class: _normalizeClass(['card-base', 'disclaimer-card', { blurred: step.value === 2 }])
      }, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("p", _hoisted_9, _toDisplayString(getDisplayText("message.applicationSubtitle")), 1),
            _createElementVNode("h2", _hoisted_10, _toDisplayString(displayTitle.value), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("h3", null, _toDisplayString(getDisplayText("message.step1Title")), 1),
              _createElementVNode("p", null, _toDisplayString(getDisplayText("message.step1Desc")), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("h3", null, _toDisplayString(getDisplayText("message.step2Title")), 1),
              _createElementVNode("p", null, _toDisplayString(getDisplayText("message.step2Desc")), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("h3", null, _toDisplayString(getDisplayText("message.step3Title")), 1),
              _createElementVNode("p", null, _toDisplayString(getDisplayText("message.step3Desc")), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _hoisted_22,
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("h3", null, _toDisplayString(getDisplayText("message.step4Title")), 1),
              _createElementVNode("p", null, _toDisplayString(getDisplayText("message.step4Desc")), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_24, [
          (primaryColor.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "primary-btn",
                onClick: handleRedirectToDisclaimer,
                style: _normalizeStyle(
                resolvedPrimaryColor.value
                  ? { backgroundColor: resolvedPrimaryColor.value }
                  : undefined
              )
              }, [
                _createVNode(_unref(FontAwesomeIcon), {
                  icon: _unref(faWhatsapp),
                  width: "24",
                  height: "24",
                  style: {"color":"#ffffff"}
                }, null, 8, ["icon"]),
                _createTextVNode(" " + _toDisplayString(getDisplayText("message.applyBtn")), 1)
              ], 4))
            : (_openBlock(), _createElementBlock("div", _hoisted_25))
        ])
      ], 2), [
        [_vShow, step.value !== 3]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_26, [
        _createElementVNode("div", _hoisted_27, [
          (showDisclaimerText.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", _hoisted_28, [
                  _createTextVNode(_toDisplayString(_unref(t)("message.consentHeader")), 1),
                  _createElementVNode("button", {
                    class: "close-btn",
                    onClick: closeConsentCard
                  }, " × ")
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(combinedDataPrivacyText.value, (part, index) => {
                      return (_openBlock(), _createElementBlock("span", { key: index }, [
                        (isPlaceholder(part))
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              (part === '{newLine}')
                                ? (_openBlock(), _createElementBlock("br", _hoisted_31))
                                : (_openBlock(), _createElementBlock("a", {
                                    key: 1,
                                    href: getPlaceholderLink(part),
                                    target: "_blank",
                                    class: "link"
                                  }, _toDisplayString(getPlaceholderLabel(part)), 9, _hoisted_32))
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode(_toDisplayString(part), 1)
                            ], 64))
                      ]))
                    }), 128))
                  ])
                ]),
                _createElementVNode("button", {
                  class: "primary-btn mt-16",
                  onClick: onAgreeDisclaimer,
                  style: _normalizeStyle({ backgroundColor: primaryColor.value })
                }, _toDisplayString(_unref(t)("message.agreeBtn")), 5)
              ], 64))
            : (_openBlock(), _createElementBlock("div", _hoisted_33))
        ])
      ], 512), [
        [_vShow, step.value === 2]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_34, [
        _createElementVNode("div", _hoisted_35, [
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("h2", _hoisted_37, _toDisplayString(_unref(t)("message.successTitle")), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_38, [
          _createTextVNode(_toDisplayString(getDisplayText("message.successDesc_1")), 1),
          _hoisted_39,
          _createTextVNode(" " + _toDisplayString(getDisplayText("message.successDesc_2")), 1),
          _hoisted_40,
          _createTextVNode(" " + _toDisplayString(getDisplayText("message.successDesc_3")), 1)
        ]),
        _createElementVNode("div", _hoisted_41, [
          _createElementVNode("div", _hoisted_42, [
            _createVNode(QrCodeComp, {
              value: qrCodeLink.value,
              logoUrl: logoPath.value + tenantLogoGuid.value,
              width: 300,
              height: 300,
              showLogo: false,
              onQrReady: onQrCodeReady
            }, null, 8, ["value", "logoUrl"]),
            (!qrImageLoaded.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_43))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("button", {
          class: "primary-btn",
          onClick: handleRedirectFromBtn,
          style: _normalizeStyle({ backgroundColor: primaryColor.value })
        }, _toDisplayString(_unref(t)("message.openDesktopBtn")), 5)
      ], 512), [
        [_vShow, step.value === 3]
      ])
    ]),
    _createElementVNode("div", _hoisted_44, [
      _createElementVNode("div", _hoisted_45, [
        (hasValidConsent.value && tenantInfo.value?.showAcceptedDisclaimer)
          ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
              _createVNode(_unref(FontAwesomeIcon), {
                icon: _unref(faCheckCircleSolid),
                width: "16px",
                height: "16px",
                style: {"font-size":"16px","color":"green"}
              }, null, 8, ["icon"]),
              _createElementVNode("a", {
                href: "#",
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (showDisclaimer()), ["prevent"]))
              }, _toDisplayString(_unref(t)("message.acceptedDisclaimerLbl")), 1)
            ]))
          : _createCommentVNode("", true),
        (tenantInfo.value?.dataPrivacyUrl)
          ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
              _createElementVNode("a", {
                target: "_blank",
                href: tenantInfo.value.dataPrivacyUrl
              }, _toDisplayString(_unref(t)("message.privacyLink")), 9, _hoisted_48)
            ]))
          : _createCommentVNode("", true),
        (tenantInfo.value?.imprintUrl)
          ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
              _createElementVNode("a", {
                target: "_blank",
                href: tenantInfo.value.imprintUrl
              }, _toDisplayString(_unref(t)("message.legalLink")), 9, _hoisted_50)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_51, [
      _createElementVNode("div", _hoisted_52, [
        _createElementVNode("div", _hoisted_53, [
          _createTextVNode(_toDisplayString(_unref(t)("message.acceptedDisclaimerLbl")), 1),
          _createElementVNode("button", {
            class: "close-btn",
            onClick: closeDisclaimer
          }, " × ")
        ]),
        _createElementVNode("div", _hoisted_54, [
          _createElementVNode("div", _hoisted_55, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(combinedDataPrivacyText.value, (part, index) => {
              return (_openBlock(), _createElementBlock("span", { key: index }, [
                (isPlaceholder(part))
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (part === '{newLine}')
                        ? (_openBlock(), _createElementBlock("br", _hoisted_56))
                        : (_openBlock(), _createElementBlock("a", {
                            key: 1,
                            href: getPlaceholderLink(part),
                            target: "_blank",
                            class: "link"
                          }, _toDisplayString(getPlaceholderLabel(part)), 9, _hoisted_57))
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(part), 1)
                    ], 64))
              ]))
            }), 128))
          ])
        ])
      ])
    ], 512), [
      [_vShow, displayDisclaimer.value]
    ])
  ]))
}
}

})